/* ESP cart upsell — global, document-delegated, SMOOTH in-place add (no page reload, no redirect).
   Trigger: any .esp-upsell-add[data-variant-id]. Dawn-style <cart-drawer> + cart page .js-contents. 2026-06-01 */
(function () {
  var TAG = '[esp-upsell]';
  if (window.__espUpsellInit) { return; }
  window.__espUpsellInit = true;
  console.log(TAG, 'script loaded');

  function parse(html){ return new DOMParser().parseFromString(html, 'text/html'); }
  function swapJsContents(id, html){
    var doc = parse(html);
    var src = doc.querySelector('#' + id + ' .js-contents') || doc.querySelector('.js-contents');
    var cur = document.querySelector('#' + id + ' .js-contents');
    if (src && cur) { cur.innerHTML = src.innerHTML; return true; }
    var s2 = doc.getElementById(id), c2 = document.getElementById(id);
    if (s2 && c2) { c2.innerHTML = s2.innerHTML; return true; }
    return false;
  }
  function setInnerById(id, html){
    var doc = parse(html);
    var src = doc.getElementById(id) || doc.querySelector('#' + id);
    var cur = document.getElementById(id);
    if (cur) { cur.innerHTML = src ? src.innerHTML : (doc.body ? doc.body.innerHTML : html); return true; }
    return false;
  }
  function openDrawer(){
    var d = document.querySelector('cart-drawer');
    if (!d) return false;
    try {
      if (typeof d.open === 'function') { d.open(); }
      else { d.classList.add('animate','active'); d.setAttribute('open',''); document.body.classList.add('overflow-hidden'); }
      console.log(TAG, 'drawer opened'); return true;
    } catch(e){ console.warn(TAG,'open failed',e); return false; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.esp-upsell-add') : null;
    if (!btn) { return; }
    e.preventDefault();
    if (btn.getAttribute('data-loading') === '1') { return; }
    var id = btn.getAttribute('data-variant-id');
    console.log(TAG, 'button click detected, variant =', id);
    if (!id) { console.warn(TAG, 'no data-variant-id'); return; }

    var original = btn.textContent;
    btn.setAttribute('data-loading','1'); btn.disabled = true; btn.textContent = 'Adding…';
    var onCartPage = /\/cart(\/|$|\?|#)/.test(window.location.pathname);
    var wanted = onCartPage ? ['main-cart-items','main-cart-footer','cart-icon-bubble'] : ['cart-drawer','cart-icon-bubble'];
    console.log(TAG, 'add started; context', onCartPage ? 'cart-page' : 'drawer', '; sections', wanted);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id,10), quantity: 1 }], sections: wanted, sections_url: window.location.pathname })
    })
    .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,status:r.status,data:d}; }); })
    .then(function(res){
      if (!res.ok) { console.error(TAG,'add FAILED',res.status,res.data); btn.textContent=original; btn.disabled=false; btn.removeAttribute('data-loading'); return; }
      console.log(TAG,'add SUCCESS', res.data && res.data.id);
      var s = res.data && res.data.sections;
      if (s && s['cart-icon-bubble']) { setInnerById('cart-icon-bubble', s['cart-icon-bubble']); }

      if (onCartPage) {
        var a = s && s['main-cart-items'] ? swapJsContents('main-cart-items', s['main-cart-items']) : false;
        var b = s && s['main-cart-footer'] ? swapJsContents('main-cart-footer', s['main-cart-footer']) : false;
        console.log(TAG,'cart page updated in place; items', a, 'footer', b);
        document.dispatchEvent(new CustomEvent('esp:cart-updated'));
        return; /* no reload */
      }
      if (s && s['cart-drawer']) {
        var doc = parse(s['cart-drawer']);
        var src = doc.getElementById('CartDrawer'); var cur = document.getElementById('CartDrawer');
        if (src && cur) { cur.innerHTML = src.innerHTML; openDrawer(); console.log(TAG,'drawer refreshed in place'); return; }
      }
      console.warn(TAG,'no smooth target found; leaving cart updated (count only)');
      btn.textContent = 'Added ✓';
    })
    .catch(function(err){ console.error(TAG,'add ERROR',err); btn.textContent=original; btn.disabled=false; btn.removeAttribute('data-loading'); });
  }, false);
})();
